import {Pipe, PipeTransform} from '@angular/core';
import {AccessType, ConnectionStatus} from '@app/modules/shared/data/constants';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';
import {LocalUser} from '@app/state/local-user.state';

@Pipe({
  name: 'unansweredMessages',
  pure: false
})
export class UnansweredMessagesPipe implements PipeTransform {
  public transform(remoteUsers: { [key: number]: RemoteParticipantInfo [] }, localUser: LocalUser, accessTypes: AccessType[], includeLocalUser: boolean = true): number {
    const unansweredMessagesCount: number = Object.values(remoteUsers)
      .reduce((accumulator, currentValue): RemoteParticipantInfo[] => accumulator.concat(currentValue), [])
      ?.filter((remoteUser) => accessTypes.includes(remoteUser.accessType))
      // .filter((remoteUser) =>
      //   remoteUser.additionalInfo.roomConnectionStatus !== ConnectionStatus.OFFLINE ||
      //   (remoteUser.accessType === AccessType.STUDENT && remoteUser.additionalInfo.isClassParticipant)
      // )
      .filter((remoteUser) => remoteUser.additionalInfo.hasUnansweredMessage)
      .length || 0;

    return unansweredMessagesCount + (includeLocalUser && localUser.hasUnansweredMessage ? 1 : 0);
  }
}
